import React from 'react'
import { Trans } from '@lingui/macro'
import { useSelector } from 'react-redux'
import { DotsVerticalIcon, MinusSmIcon } from '@heroicons/react/outline'
import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink'
import { getColor } from 'components/utils'
import { Alert } from 'components/UI/Alert/Alert'
import { IdUsersState } from 'model/dashboardUsers/dUsersReducer'
import { allowEditUser, getTransPosition } from 'constants/userPositions'
import { ISystemState } from 'model/system/systemReducer';


// Type
export type typeTableHeader = {
    variant?: string

}

// Header data component
export const TableHeader: React.FC<typeTableHeader> = () => {

    return (

        <>

            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>User name</Trans>
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Position</Trans>
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Phone number</Trans>
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Email</Trans>
            </th>

            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Store name</Trans>
            </th>
            <th scope="col" className="w-1">
            </th>
        </>

    )
}

// Type
export type typeAction = {
    title: JSX.Element,
    disableSwitcher?: boolean,
    action: ( id: string ) => void,
}

export type typeTableBody = {
    variant?: string
    rowsActions: typeAction[]
}

// Body data component
export const TableBody: React.FC<typeTableBody> = ( { variant, rowsActions } ) => {

    const color = getColor(variant)

const userInfo = useSelector(( state: { system: ISystemState } ) => state.system.userInfo)

    const tableData = useSelector(( state: { dUsers: IdUsersState } ) => state.dUsers.data)

    let component

    if (tableData.length) {
        component = tableData.map(( item, index ) => {
            return (
                <tr key={item.id}
                    className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-${color}-50`}>
                    <td className="px-4 py-3  text-sm font-medium text-left text-gray-900 "> {item.name}{item.deleted ? ' ' : null}{item.deleted ?
                        <span
                            className="text-xs text-gray-400 font-normal"><Trans>(deleted)</Trans></span> : null} </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 ">
                        {item.position ? getTransPosition(item.position) :
                            <div className="flex"><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}
                    </td>
                    <td className="px-4 py-3 break-words text-sm text-left text-gray-500 ">
                        {item.phoneNumber ? item.phoneNumber :
                            <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}
                    </td>
                    <td className="px-4 py-3 break-all text-sm text-left text-gray-500 ">
                        {item.email ? item.email :
                            <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}
                    </td>
                    <td className="px-4 py-3  text-sm text-gray-500 break-all ">{ item.store? item.store.name :
                        <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}</td>
                    <td className="whitespace-nowrap text-sm text-gray-500 pr-2">
                        <div className="relative flex">{ (userInfo && allowEditUser(userInfo.position!, userInfo.authorizedUser.userId, item) )&&
                            <div className=" row-action-block">
                                <DotsVerticalIcon className="row-action-list-open-button h-5 w-5 text-gray-900"/>
                                <div className="row-action-list">
                                    <div className="flex gap-x-4">
                                        { rowsActions.map((actionItem, ActionIndex) => {
                                                              const link = <ButtonLink key={ ActionIndex } type={ 'button' }
                                                                                       label={ actionItem.title }
                                                                                       onClick={ () => actionItem.action(item.id) }/>
                                                              if ('id' in actionItem) {
                                                                  // @ts-ignore
                                                                  switch (actionItem.id) {
                                                                      case 'recover':
                                                                          if (item.deleted) return link
                                                                          break
                                                                      case 'delete':
                                                                          if (!item.deleted) return link
                                                                          break
                                                                  }
                                                              } else {
                                                                  return item.deleted ? null : link
                                                              }
                                                              return null
                                                          }
                                        ) }
                                    </div>
                                </div>
                            </div> }
                        </div>
                    </td>
                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={5}>
                <Alert className="w-full" type={'info'}
                       title={<Trans>The users list is empty. Click Add button to create new user or check filters.</Trans>}/>
            </td>
        </tr>
    }

    return (
        <>
            {component}
        </>
    )
}
